<template>
  <div class="content-quiz content-quiz-body">
    <div class="question" tabindex="0" v-html="currentQuestion.content"></div>
    <ul class="answers">
      <answer v-for="(answer, index) in currentQuestion.answers"
              v-bind:answer="answer"
              v-bind:index="index"
              v-bind:key="answer.id">
      </answer>
    </ul>
  </div>
</template>
<script>
import Answer from './answer.vue'

export default {
  props: {
    currentQuestion: {
      type: Object
    }
  },
  components: {
    Answer
  }
}
</script>

